<template>
  <!-- 订单头部状态组件 -->
  <div class="statusBox">
    <div class="showStatus">
      <van-icon :name="data.icon" color="#3088c5" />
      <div class="statusInf">
        <span>{{ data.statusDesc }} </span>
        <span v-if="data.en === 'awaitPay' && data.residueTime > 0" class="residue error">
          <van-count-down :time="data.residueTime" format="HH:mm:ss" @finish="refresh" />
          后失效
        </span>
        <p class="other error" v-if="data.failReason">备注：{{ data.failReason }}</p>
        <p class="other" v-if="data.en === 'awaitSureRefund' && data.returnTime > 0">
          <van-count-down :time="data.returnTime" format="HH:mm:ss" @finish="refresh" />
          后金额自动退回
        </p>
      </div>
    </div>
    <div class="refundMessage" v-if="data.refundMessage">
      {{ data.refundMessage }}
    </div>
    <div class="refundStep" v-if="data.showActive">
      <van-steps :active="data.active" active-color="#3088c5">
        <van-step>发起退款</van-step>
        <van-step>退款中</van-step>
        <van-step>{{ data.refundStatusFlag == 5 ? '退款失败' : '退款到账' }}</van-step>
      </van-steps>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, { emit }) {
    let { data } = toRefs(props)
    const state = reactive({
      data: data.value
    })
    const refresh = () => {
      emit('refresh')
    }
    return {
      ...toRefs(state),
      refresh
    }
  }
}
</script>
<style lang="scss" scoped>
.statusBox {
  padding: 3px 10px 10px;
  border-bottom: 1px solid #c9c9c9;
}
.showStatus {
  text-align: left;
  vertical-align: top;
  .van-icon {
    padding-top: 3px;
  }
}

.refundMessage {
  text-align: left;
  margin: 10px 0 8px 25px;
}

.statusInf {
  display: inline-block;
  width: calc(100% - 30px);
  padding-left: 10px;
  color: #3088c5;
  vertical-align: top;
  .van-count-down {
    display: inline-block;
  }
}
.residue {
  margin-left: 5px;
}
.other {
  margin-top: 6px;
  font-size: 12px;
  color: #666;
}
.error {
  color: #c30000;
}
.van-step__title {
  color: #c30000 !important;
}
// 步骤条样式错乱，需要手动处理
.refundStep {
  :deep(.van-step--horizontal:first-child .van-step__title) {
    position: absolute;
    left: 0;
    width: auto;
  }
  :deep(.van-steps__items) {
    margin: 0 0 16px !important;
  }
  :deep(.van-step--horizontal:nth-child(2) .van-step__title) {
    position: absolute;
    left: 0;
    right: 0;
    width: auto;
  }
}
</style>
